enum SearchTargetType {
  User = 'User',
  Group = 'Group'
}

export default SearchTargetType;
